import {
  BubbleMenu as BubbleMenuPrimitive,
  BubbleMenuProps,
} from "@tiptap/react";
import { twMerge } from "tailwind-merge";

export const BubbleMenu = ({
  children,
  className,
  ...rest
}: Omit<BubbleMenuProps, "editor">) => {
  return (
    <BubbleMenuPrimitive
      className={twMerge(
        "border-grey-200 max-w-[calc(100vw-16px)] animate-in fade-out-0 fade-in-0 zoom-out-95 zoom-in-95 slide-in-from-bottom-2 z-50 rounded-lg border bg-white shadow-xs duration-100",
        className,
      )}
      editor={null}
      {...rest}
    >
      {children}
    </BubbleMenuPrimitive>
  );
};
